<template>
  <div class="content_box">
    <van-radio-group v-model="currentConsId" @change="changeCons">
      <van-cell-group>
        <van-cell
          :label="item.elecAddr"
          clickable
          v-for="item in accountList"
          @click="radio = item.consId"
        >
          <template #title>
            <span class="custom-title">{{item.consName}}({{item.consNo}})</span>
          </template>
          <template #right-icon>
            <van-radio :name="item.consId" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
import { queryBindConsNoList } from "@/api/user.js";
import Vue from "vue";
import { RadioGroup, Radio } from "vant";
import { Cell, CellGroup } from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  data() {
    return {
      radio: 1,
      currentConsId: "",
      accountList: []
    };
  },
  created() {
    this.currentConsId = this.$route.query.consId;
    this.queryBindConsNoList();
  },
  methods: {
    queryBindConsNoList() {
      queryBindConsNoList().then(res => {
        if (res.data.status == 200) {
          this.accountList = res.data.object;
        }
      });
    },
    changeCons(name) {
      this.$router.push({
        path: `/tcmr/electricityHistory?consId=${name}`
      });
    }
  }
};
</script>

<style scoped>
.van-cell__title {
  text-align: left;
}
.elecAddr {
  font-size: 0.24rem;
  margin-top: 0.05rem;
}
.consName {
  font-size: 0.28rem;
  font-weight: 700;
}
.consNo {
  font-size: 0.24rem;
  margin-top: 0.05rem;
}
</style>